import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Refresh Stroke
 */

export default function RefreshStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M0.375 0.25H1.21875C1.4375 0.25 1.59375 0.4375 1.59375 0.65625L1.53125 3.71875C2.90625 1.625 5.3125 0.25 8 0.28125C12.2812 0.28125 15.75 3.78125 15.75 8.03125C15.7188 12.3125 12.25 15.75 8 15.75C6 15.75 4.15625 15 2.78125 13.7812C2.625 13.625 2.625 13.375 2.78125 13.2188L3.40625 12.5938C3.53125 12.4688 3.75 12.4688 3.90625 12.5938C5 13.5625 6.40625 14.125 8 14.125C11.375 14.125 14.125 11.4062 14.125 8C14.125 4.625 11.375 1.875 8 1.875C5.5 1.875 3.375 3.375 2.40625 5.5L6.34375 5.40625C6.5625 5.40625 6.75 5.5625 6.75 5.78125V6.625C6.75 6.84375 6.5625 7 6.375 7H0.375C0.15625 7 0 6.84375 0 6.625V0.625C0 0.4375 0.15625 0.25 0.375 0.25Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
